module.exports = App.MapDraggabilityMixin = Ember.Mixin.create
  draggableDidChange: Ember.observer('draggable', ->
    if @get('draggable')
      @_layer.dragging.enable()
    else
      @_layer.dragging.disable()
    return
  )